import React from "react";
import MultipleChoiceFilter from "shared/components/MultipleChoiceFilter/MultipleChoiceFilter";
import { NoteSubject } from "view360Card/features/notes/models";
import styles from "./subjectsDropdown.module.scss";

export interface ISubjectsDropdownProps {
    formDisabled: boolean;
    noteSubjectsList: NoteSubject[] | undefined;
    selectedSubjects: NoteSubject[] | undefined;
    onSelectionChanged: (selectedItems: any) => void;
}

const SubjectsDropdown: React.FC<ISubjectsDropdownProps> = ({
    formDisabled,
    noteSubjectsList,
    selectedSubjects,
    onSelectionChanged,
}) => {

    return (
        <MultipleChoiceFilter
            availableChoices={noteSubjectsList?.map((x) => ({ value: x, valueAsString: x.text })) ?? []}
            selectedChoices={selectedSubjects?.map((x) => ({ value: x, valueAsString: x.text })) ?? []}
            onSelectionChanged={(selectedItems: any) => onSelectionChanged(selectedItems)}
            notInverted
            placeholder="Wybierz temat"
            disabled={formDisabled}
            className={styles.mulitpleDropdown}
            clearable
        />
    )
}

export default SubjectsDropdown;
